import { skipToken } from '@reduxjs/toolkit/query'
import { useFetchAgentInfoQuery } from '@/api/influencer-api'
import { useFetchUserInfoQuery, useFetchUserStatusQuery } from '@/api/user-api'
import { useAuth } from '@/hooks/use-auth'
import { Page } from '@/hooks/use-authorization/constants'
import getUserDefaultPage from '@/hooks/use-authorization/get-user-default-page'

interface UseDefaultPage {
  (): Page
}

const useDefaultPage: UseDefaultPage = () => {
  const { isAd } = useAuth()
  const { data: user } = useFetchUserInfoQuery()
  const { data: workspaceStatus } = useFetchUserStatusQuery(
    isAd ? undefined : skipToken,
  )
  const { data: agentInfo } = useFetchAgentInfoQuery(
    isAd ? skipToken : undefined,
  )

  return user
    ? getUserDefaultPage(user.type, workspaceStatus, agentInfo)
    : Page.Login
}

export default useDefaultPage
